import React from 'react';
import { FormCheck } from 'react-bootstrap';
import { mergeClassNames } from '../../style';

export interface ToggleSwitchButtonProps {
  checked: boolean;
  children: React.ReactNode;
  disabled?: boolean;
  id: string;
  onClick: VoidFunction;
}

export const ToggleSwitchButton = ({
  checked,
  children,
  disabled = false,
  id,
  onClick,
}: ToggleSwitchButtonProps): JSX.Element => {
  const buttonClass = mergeClassNames([
    { className: 'text-center title-wrapper btn-no-borders toggle-control' },
    { className: 'btn-disabled', include: disabled },
    { className: 'toggle-control-checked', include: checked },
  ]);
  return (
    <button className={buttonClass} onClick={onClick} type="button" tabIndex={0} disabled={disabled}>
      <span className="title ms-2">{children}</span>
      <FormCheck
        className="fw-normal ms-2"
        checked={checked}
        disabled={disabled}
        type="switch"
        id={id}
        label=""
        readOnly
      />
    </button>
  );
};
